

const postalCodeValidatorCA = (postcode) => {
    const pattern = new RegExp(/^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$/);
    return postcode && pattern.test(postcode);
};

export default postalCodeValidatorCA;
